import { render, staticRenderFns } from "./MdSignotec.vue?vue&type=template&id=babc885a&"
import script from "./MdSignotec.vue?vue&type=script&lang=js&"
export * from "./MdSignotec.vue?vue&type=script&lang=js&"
import style0 from "./MdSignotec.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports